import { gql } from '@apollo/client';

export const RESTART_TELEGRAM_BOT = gql`
    mutation RestartTelegramBot {
        restartTelegramBot {
            success
            message
            isRunning
            restartAttempts
            persistentConflictDetected
        }
    }
`;

